import { useAtom } from '@reatom/npm-react'
import { format } from 'date-fns/format'
import { enUS } from 'date-fns/locale/en-US'
import { ru } from 'date-fns/locale/ru'
import { useTranslation as _useTranslation } from 'react-i18next'

import { languageAtom, type TransKey } from '../atoms'

import type { FormatOptions } from 'date-fns/format'

/*
After adding more than 280 keys, original t function started to infer return type of (t) strangely
*/

export type StrictTransFn = (key: TransKey, opts?: object) => string

export const useTranslation = (): { t: StrictTransFn } => {
  const { t } = _useTranslation()

  return { t: t as StrictTransFn }
}

export const useDateFnsLocale = () => {
  const [lang] = useAtom(languageAtom)

  if (lang === 'ru') {
    return ru
  }
  return enUS
}

export const useDateFormat = () => {
  const locale = useDateFnsLocale()

  return {
    formatDate: <DateType extends Date>(
      date: DateType | number | string,
      formatStr: string,
      options?: FormatOptions,
    ) => format(date, formatStr, { locale, ...options }),
  }
}
